module.exports = __webpack_public_path__ + "media/images/plus-500651519559e13a7330f6c9800e9df9.svg";